import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { assetsSchemaRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsSchemaRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { ObjectSchemaV2 } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/ui/object-schema/index.tsx';
import { assetsSchemaEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-object-schema-v2/src/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsSchemaPageEntryPoint = createChromelessEntryPoint({
	main: assetsSchemaEntryPoint,
});

export const assetsSchemaRouteEntry = createEntry(assetsSchemaRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	component: ObjectSchemaV2,
	entryPoint: () => assetsSchemaPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-object-schema',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
}));
